import { createSlice } from "@reduxjs/toolkit";
import { getDocs } from "../../api/docs";

const initialState = {
  docs: {},
  docsLoading: false,
};

const docsSLice = createSlice({
  name: "docs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDocs.pending, (state) => {
        state.docsLoading = true;
      })
      .addCase(getDocs.fulfilled, (state, { payload, meta }) => {
        state.docs[meta.arg.direction] = payload?.map((item) => ({
          id: item?.id,
          title: item?.name,
          direction: item?.direction,
          files: item?.docs?.map((doc) => ({
            id: doc?.id,
            file: doc?.doc,
            name: doc?.name,
          })),
        }));
        state.docsLoading = false;
      })
      .addCase(getDocs.rejected, (state, { error }) => {
        state.docsLoading = false;
        console.log(error);
      });
  },
});

export default docsSLice.reducer;
// export const {} = importSlice.actions;
